import { useNavigate, useParams } from "react-router-dom";

type UseNavigateToReportOverviewParams = {
  tenantId: string;
  reportId: string;
};

export const useNavigateReportSaveCancel = () => {
  const { tenantId, reportId } = useParams<UseNavigateToReportOverviewParams>();
  const navigate = useNavigate();
  const navigateReportSaveCancel = () => {
    navigate(`/o/${tenantId}/chemicals/reports/${reportId}`);
  };

  return navigateReportSaveCancel;
};
